export default {
  default: {
    title: 'No Document or File Libraries',
    paragraph: 'You don’t have any document or file libraries in your agency yet. You can store and call documents from your libraries into marketing pages.',
  },
}
